import { render, staticRenderFns } from "./ArchivePurchaseModal.vue?vue&type=template&id=ff0367b8&"
import script from "./ArchivePurchaseModal.vue?vue&type=script&lang=js&"
export * from "./ArchivePurchaseModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ArchivePurchaseModal.vue"
export default component.exports